module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": 0
    }
  }, [_c('communication-template-list', {
    attrs: {
      "title": _vm.$t("comms.title"),
      "context": _vm.templateContext
    },
    on: {
      "selected": _vm.setSelectedCommunicationTemplate,
      "new": _vm.setCrud
    }
  })], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 1
    }
  }, [_c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [(_vm.title) ? _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.sender && _vm.sendToMe) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('recipient-card', {
    attrs: {
      "title": "Send to me"
    },
    on: {
      "sendTo": _vm.setSendToMe
    },
    model: {
      value: (_vm.sender),
      callback: function($$v) {
        _vm.sender = $$v
      },
      expression: "sender"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.recipients), function(recipient, index) {
    return _c('v-flex', {
      key: recipient.id,
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('recipient-card', {
      attrs: {
        "template-slug": _vm.template,
        "sender": _vm.sender,
        "context": _vm.context
      },
      on: {
        "sendTo": _vm.setSendTo
      },
      model: {
        value: (_vm.recipients[index]),
        callback: function($$v) {
          _vm.$set(_vm.recipients, index, $$v)
        },
        expression: "recipients[index]"
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.withSend) ? _c('v-card-actions', [(_vm.withCancel) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.sendRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.withSend) ? _c('v-window-item', {
    attrs: {
      "value": 2
    }
  }, [_c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('message-delivery-status', {
    attrs: {
      "batch-id": _vm.batchId
    }
  }), _vm._v(" "), (_vm.withSend) ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.page = 0
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 3
    }
  }, [_c('communication-template-form', {
    attrs: {
      "context-type": "Appointment"
    },
    on: {
      "close": function($event) {
        _vm.page = 0
      }
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94944bb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unibox/SendTemplate.vue
// module id = 1498
// module chunks = 9